<template>
  <Modal :title="`定休日または営業時間外が\n選択されています`" hideCloseButton @close="onClose">
    <p class="text">先に進んでよろしいでしょうか？</p>
    <template #footer-center>
      <Button @click="onClose">いいえ</Button>
      <StaffSelectPopover placement="top-end" @update:open="isShowStaffList = $event" @select="selectStaff">
        <Button primary :disabled="isShowStaffList">はい</Button>
      </StaffSelectPopover>
    </template>
  </Modal>
</template>

<script>
import Button from '@/components/atoms/Button'
import Modal from '@/components/molecules/Modal'
import StaffSelectPopover from '@/components/organisms/StaffSelectPopover'

export default {
  name: 'BusinessHoursAlertModal',
  components: {
    Button,
    Modal,
    StaffSelectPopover,
  },
  data() {
    return {
      isShowStaffList: false,
    }
  },
  computed: {},
  methods: {
    onClose() {
      this.$emit('close')
    },
    selectStaff(staff) {
      this.$emit('confirm', staff)
      this.onClose()
    },
  },
}
</script>

<style lang="postcss" scoped>
.text {
  line-height: 1.4;
  text-align: center;
}
</style>
